
























































































import { Prop, Component, Vue, Inject, Ref, Watch, InjectReactive } from "vue-property-decorator";
import { shortDayNames, trunc, getDay, Day } from "../date-picker/private/Utils";
import AButton from "../date-picker/private/AButton.vue";
import { BPopover } from "bootstrap-vue";

@Component({
    components: {
        AButton,
        BPopover,
    },
})
export default class AbcDayYearTooltip extends Vue {
    @Ref("element") el!: AButton;

    @Inject() setCurDate!: (dt: Date) => void;
    @Inject() isMondayFirst!: boolean;

    @Prop() localDate!: Date;
    @Prop() isCurrent!: boolean;

    private closePopover() {
        this.$root.$emit("bv::hide::popover", "day-tooltip-target-" + this.localDate.getTime());
    }

    private get day() {
        const names = shortDayNames(this.isMondayFirst);
        const index = getDay(this.localDate, this.isMondayFirst);

        return names[index];
    }

    private get dayName() {
        const names = shortDayNames(this.isMondayFirst);
        const index = getDay(this.localDate, this.isMondayFirst);

        return names[index];
    }

    private truncDate(dt: Date) {
        return trunc(dt);
    }
}
